import { RootState } from '../root.reducers';
import { TlsProfile } from './tlsProfile.types';

export const getTlsProfileList = (state: RootState): TlsProfile[] =>
  state.tlsProfile.entities;

export const getTlsProfile = (state: RootState): TlsProfile | null =>
  state.tlsProfile.single;

export const getSelectedTlsProfile = (state: RootState): TlsProfile[] =>
  state.tlsProfile.selected;

export const getTlsProfileCreatedId = (state: RootState): string | null =>
  state.tlsProfile.createdId;

export const isTlsProfileCreatePopupOpen = (state: RootState): boolean =>
  state.tlsProfile.ui.isCreatePopupOpen;

export const isTlsProfileLoading = (state: RootState): boolean =>
  state.tlsProfile.ui.isLoading;
